export const userStateActionType = Object.freeze({
    setUser: 'SET_USER',
    deleteUser: 'DELETE_USER',
})

export function setUser(user) {
    return (dispatch) => {
        dispatch({
            type: 'SET_USER',
            payload: user
        })
    }
}

export function resetUser() {
    
    return (dispatch) => {
        dispatch({
            type: userStateActionType.deleteUser,
            payload: null
        })
    }
}